import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Grid, makeStyles, TableContainer } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Table from "components/UpdateUi/Table/Table";
import { parseDateMDY } from "utils/Utils";
import Button from "../../components/CustomButtons/Button.js";
import { formatAmount } from "utils/Utils";
import { emiScheduleList } from "assets/properties/properties.js";
import { endpoint } from "assets/api/endpoint.js";
import { apiHandler } from "assets/api/index.js";
import CircularProgresss from "views/components/CircularProgress/CircularProgress.js";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ToastModal from "views/components/ToastModal.js";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
}));
const EmiSchedule = () => {
    const classes = useStyles();
    const [installments, setinstallments] = useState([]);
    const location = useLocation();
    const loanNumber = location.state?.loanNumber;
    const { authToken } = useSelector((state) => state.login.authData);
    const [callInProgress, setCallInProgress] = useState(false);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastMessageType, setToastMessageType] = useState("");
    const toastUpdate = (type, message, showToast) => {
      setToastMessageType(type);
      setToastMessage(message);
      setToast(showToast);
    };
    useEffect(() => {
        if (loanNumber) {
          fetchLoanSummary();
        }
      }, [loanNumber]);
    
      const fetchLoanSummary = async () => {
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.USESR_EMI_REPAYMENT_DATA_API + loanNumber,
          authToken: authToken,
        });
        setCallInProgress(false);
        if(result?.data?.error_code === 401){
          toastUpdate("Error", result?.data?.user_description, true);
        }else{
          const combinedInstallments = [
            ...result?.data?.paidInstallments.map(installment => ({ ...installment, colour: true })),
            ...result?.data?.upcomingInstallments
          ];
          parseIndicatorData(combinedInstallments);
        }
      };
  const parseIndicatorData = async (res) => {
        let reportData = [];
        res &&
          res?.forEach((decisionDetails, index) => {
            let row = {
              label: index + 1,
              principalAmount: formatAmount(decisionDetails?.amount),
              date: parseDateMDY(decisionDetails?.dueDate),
              paid: decisionDetails.paid ? 'Yes' : 'No',
              colourCheck: decisionDetails?.colour,
            };
            reportData.push(row);
          });
          setinstallments(reportData);
        };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Installment Schedule"
          button1="Back"
          button1click={() => window.history.back()}
          noButton
        />
      </Grid>
      {installments.length > 0 &&
      <TableContainer>
            <Table
              columns={emiScheduleList}
              rows={installments}
              styles="style"
              checkDate
            />
          </TableContainer>
    }
              {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
              {toast && (
                      <ToastModal
                        toastMessage={toastMessage}
                        toastMessageType={toastMessageType}
                        toastUpdate={toastUpdate}
                      />
                    )}
      </Grid>
  );
};
EmiSchedule.propTypes = {
  classes: PropTypes.object,
};
export default EmiSchedule;